import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import DOMPurify from "dompurify";

// Content authored by the trusted super-admin. If it contains HTML tags (from the
// rich text editor) render it as sanitized HTML; otherwise treat it as markdown.
const looksLikeHtml = (s) => /<\/?[a-z][\s\S]*>/i.test(s || "");

export function renderLegalHtml(content) {
  return DOMPurify.sanitize(content || "", {
    ALLOWED_TAGS: ["p", "div", "br", "span", "b", "strong", "i", "em", "u", "s", "a", "ul", "ol", "li", "h1", "h2", "h3", "h4", "blockquote", "font"],
    ALLOWED_ATTR: ["style", "href", "target", "rel", "size", "color"],
  });
}

export function LegalContent({ content, className = "", ...rest }) {
  if (!content || !content.trim()) return null;
  if (looksLikeHtml(content)) {
    return <div className={className} {...rest} dangerouslySetInnerHTML={{ __html: renderLegalHtml(content) }} />;
  }
  return (
    <div className={className} {...rest}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
    </div>
  );
}
